import styled from "styled-components"
import ActionButton from "../../actionButton"

export const StyledSettingsBtn = styled(ActionButton)`
	width: 30%;
    height: auto;
    font-size: 32px;
    flex-direction: column;
    padding: var(--spacing-sm);
`

export const StyledCleanCacheText = styled.span`
	font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    font-weight: 400;
    white-space: normal;
`

